/* 🤖 this file was generated by svg-to-ts */
export const matIconCloudQueue: {
  name: 'cloud-queue';
  data: string;
} = {
  name: 'cloud-queue',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"/></svg>`
};
